:host {
    display: block;
    --header-without-aside-height: 70px;
    --header-with-aside-height: 102px;
}

#onboarding-view {
    margin-top: var(--header-with-aside-height);
}

@media screen and (max-width: 768px) {
    #onboarding-view {
        margin-top: var(--header-without-aside-height);
    }
}
